import { render, staticRenderFns } from "./PrincipalHeader.vue?vue&type=template&id=6e52278d&scoped=true&"
import script from "./PrincipalHeader.vue?vue&type=script&lang=js&"
export * from "./PrincipalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrincipalHeader.vue?vue&type=style&index=0&id=6e52278d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e52278d",
  null
  
)

export default component.exports